<template>
  <teleport to="body">
    <div :class="fadeTransition" class="modal">
      <div :class="bounceTransition" class="modal-body">
        <div class="close-svg" @click="closeModal">
          <CloseSVG :propId="'print-close'" :fillColor="'#f7f9fc'" />
        </div>
        <h1 class="modal-header">
          <div id="return" @click="returnToTroubleShooting">
            <img src="@/assets/blue-arrow-left.svg" />
            <span>Return to Troubleshooting</span>
          </div>
        </h1>
        <div class="modal-content">
          <div id="info">
            <div id="title">My printed page is too small</div>
            <p>
              If the size of your artwork is smaller than the actual labels on your sheet you will
              need to configure the
              <strong>scale</strong> in your printer settings. Set the
              <strong>scale</strong> setting to
              <strong>100%</strong> or
              <strong>Actual Size</strong>. Never print your labels at a Custom Scale, Fit to Page
              or using the Shrink Oversized Pages setting.
            </p>
            <div v-if="clientDimensions.width <= 900" id="img-wrap">
              <img src="@/assets/printing-assets/issue-1.svg" />
            </div>
            <div id="contact">
              <h2>Need more help? We're here!</h2>
              <p>
                Our expert customer service team is ready to help you with any questions or concerns
                you may have. Real time help is available
                <strong>Monday through Friday 9AM-6pm EST</strong>
              </p>
              <div id="contact-info">
                <div>
                  <img src="@/assets/phone.svg" />
                  <a href="tel:888-388-2502">888-388-2502</a>
                </div>
                <div>
                  <img src="@/assets/mail.svg" />
                  <a href="mailto:support@sheetlabels.com">support@sheetlabels.com</a>
                </div>
              </div>
            </div>
          </div>
          <div v-if="clientDimensions.width > 900" id="img-wrap">
            <img src="@/assets/printing-assets/issue-1.svg" />
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script lang="ts">
import { defineComponent, computed, Ref, inject } from "vue";
import { store } from "@/store";
import CloseSVG from "@/components/CloseSVG.vue";
import { ClientDimensions } from "@/types";
import { ActionTypes } from "@/store/actions";

export default defineComponent({
  name: "SmallPage",
  components: {
    CloseSVG,
  },
  setup() {
    const closeModal = inject("closeModal") as () => void;
    const bounceTransition = inject("bounceTransition") as Ref<string>;
    const fadeTransition = inject("fadeTransition") as Ref<string>;

    const clientDimensions = computed<ClientDimensions>(() => store.getters.clientDimensions);

    const returnToTroubleShooting = () => {
      store.dispatch(ActionTypes.SET_MODAL, "troubleShooting");
    };

    return {
      closeModal,
      bounceTransition,
      fadeTransition,
      clientDimensions,
      returnToTroubleShooting,
    };
  },
});
</script>

<style scoped>
.modal-body {
  padding: 4rem;
  height: auto;
  max-height: 90vh;
  overflow: auto;
}

.modal-header {
  color: #000;
  padding-left: 2rem;
}

#return {
  display: flex;
  align-items: center;
  font-size: 1.5rem;
  color: #0096ff;
  cursor: pointer;
}

#return img {
  margin-right: 0.5rem;
  height: 1.5rem;
}

.modal-content {
  display: flex;
  justify-content: space-between;
}

#info {
  display: flex;
  flex-direction: column;
  padding: 2rem;
}

#info,
#img-wrap {
  width: 50%;
}

#title {
  display: flex;
  align-items: center;
  font-size: 3rem;
  font-weight: 700;
}

#info > * {
  margin: 2rem 0;
}

#info > p {
  font-size: 1.5rem;
}

#contact {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  background: #f7f9fc 0% 0% no-repeat padding-box;
  box-shadow: 0px 0.9px 2px #00000029;
  border-radius: 6px;
}

#contact h2 {
  font-size: 2.5rem;
  color: #0096ff;
}

#contact > p {
  font-size: 1.5rem;
  padding: 2rem 0;
}

#contact-info {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

#contact-info div {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #0096ff;
  font-size: 1.5rem;
  width: 45%;
  word-break: break-all;
}

#contact-info div:first-child {
  justify-content: flex-start;
}

#contact-info div:last-child {
  justify-content: flex-end;
}

#contact-info div img {
  margin-right: 0.5rem;
}

#contact-info a {
  text-decoration: none;
  color: #0096ff;
}

#img-wrap {
  padding: 2rem;
  display: flex;
  align-items: center;
}

#img-wrap img {
  width: 100%;
  height: auto;
  max-width: 380px;
  margin: auto;
}

@media (max-width: 900px) {
  .modal-body {
    padding: 4rem 2rem 2rem 2rem;
  }

  .modal-content {
    height: auto;
  }

  #info {
    width: 100%;
    align-items: center;
  }

  #img-wrap {
    padding: 0;
  }
}

@media (max-width: 550px) {
  .modal-body {
    height: 90%;
    width: 95%;
    max-height: none;
  }
}
</style>
